import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";

import type { TopicStatus } from "./Drill";

// Состояние темы: учишь, понята в тренировке, исправлена в матчах.
export const STATUS_LABELS: Record<TopicStatus, MessageDescriptor> = {
  learning: msg({ id: "drills.status.learning", message: "Learning" }),
  understood: msg({ id: "drills.status.understood", message: "Understood" }),
  fixed: msg({ id: "drills.status.fixed", message: "Fixed in matches" }),
};
